import {useState} from 'react';
import {View} from 'react-native';
import moment from 'moment';

import {Pressable, Dialog, Text} from '~/components/controls';
import Format from '~/lib/format';

import sy from '~/styles';

import WarningIcon from '~/images/md-icons/warning/materialsymbolsoutlined/24px.svg';
import PropTypes from 'prop-types';

const ServiceWarning = ({style, service}) => {
  const [showDialog, setShowDialog] = useState(false);

  if (!service?.kilometrage) {
    return null;
  }

  if (service.kilometrage > 11000) {
    return null;
  }

  if (
    service.last &&
    moment(service.last).isBefore(moment().subtract(11, 'months'))
  ) {
    return <></>;
  }

  if (
    service.last == null &&
    service.ascription &&
    moment(service.ascription).isBefore(moment().subtract(11, 'months'))
  ) {
    return null;
  }

  let dialogText = null;
  if (service.last) {
    dialogText = (
      <Text>
        Laatst bekende beurt op {moment(service.last).format('D MMMM YYYY')}.
        <> ({Format.number(service.kilometrage, 0, true)} km geleden)</>
      </Text>
    );
  } else if (service.ascription) {
    dialogText = (
      <Text>
        Eerste toelating op {moment(service.ascription).format('D MMMM YYYY')}
        <> ({Format.number(service.kilometrage, 0, true)} km geleden)</>.
      </Text>
    );
  }

  return (
    <>
      <Pressable
        style={style}
        onPress={() => setShowDialog((prevState) => !prevState)}>
        <WarningIcon fill="#FF6C00" height={18} width={18} />
      </Pressable>
      <Dialog
        title="Al toe aan onderhoud?"
        titleIcon={<WarningIcon fill="#FF6C00" />}
        visible={showDialog}
        onDismiss={() => setShowDialog(false)}>
        <View style={[sy['py-4']]}>{dialogText}</View>
      </Dialog>
    </>
  );
};
ServiceWarning.propTypes = {
  style: PropTypes.any,
  service: PropTypes.any,
};

export default ServiceWarning;
